import { useEffect, useState } from "react"
import styles from 'styles/NewsDetail.module.css';
import blogStyles from 'styles/Blog.module.css';
import { NewsDetailData } from 'interfaces/news';
import { getNewsDetail } from 'lib/api/news';
import DefaultThumbnail from 'assets/images/news/AREA_CUP_logo_original.png';
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet-async";

const NewsDetail = () => {
  const { urlHash } = useParams<{ urlHash: string }>();
  const [newsDetailData, setNewsDetailData] = useState<NewsDetailData>();
  const [loading, setLoading] = useState<boolean>(true);


  const handleGetNewsDetail = async () => {
    if (!urlHash) {
      console.error("URL hash is undefined");
      setLoading(false);
      return;
    }

    try {
      const res = await getNewsDetail(urlHash);

      if (res.status === 200) {
        setNewsDetailData(res.data);
      }
    } catch (error) {
      console.error("Error fetching news detail:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleGetNewsDetail()
  }, [])

  const formatDateTime = (dateInput: Date): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
    // 年月日
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    // 時間
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${year}.${month}.${day} ${hours}:${minutes}`;
  };

  return (
    <>
      <div className={styles["background"]}>
        <div className={styles["container"]}>
          {loading && <div className={styles["loading"]}>Loading...</div>}
          {!loading && newsDetailData && (
            <>
              <Helmet>
                <title>{newsDetailData.title} | AREA CUP</title>
                <meta property="og:title" content={`${newsDetailData.title} | AREA CUP`} />
                <meta name="twitter:title" content={`${newsDetailData.title} | AREA CUP`} />
              </Helmet>
              <div className="title">
                {newsDetailData.title}
              </div>
              <hr className={styles["custom-hr"]} />
              <div className={styles["card-content-info"]}>
                <span className={styles["date"]}>
                  {formatDateTime(newsDetailData.releasedAt)}
                </span>
                <span
                  className={styles["label"]}
                  style={{ backgroundColor: newsDetailData.newsLabelColorCode }}
                >
                  {newsDetailData.newsLabel}
                </span>
              </div>
              <img src={newsDetailData.thumbnail || DefaultThumbnail} alt={newsDetailData.title} />
              <div className={blogStyles["markdown"]}>
                <ReactMarkdown>{newsDetailData.body}</ReactMarkdown>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NewsDetail;
